// extracted by mini-css-extract-plugin
export default {"cartHead":"styles_cartHead__ntV-I","cartClose":"styles_cartClose__SYgqJ"};